<template>
  <div class="wrap">
    <img class="wrapBgc" src="https://p2.ssl.qhimg.com/t01e78b25ec15b69b10.png" alt="背景图" />
    <p class="wrapTitle">论坛介绍</p>
    <p class="wrapDesc">FORUM INTRODUCTION</p>
    <div class="wrapNav">
      <div class="wrapNavImg">
        <img :src="info[pitch]?.img" :alt="info[pitch]?.name" />
        <div class="desc">
          <p class="descName">
            <span class="multiLine">{{ info[pitch]?.name }}</span>
          </p>
          <p class="descMore" @click="toMore(info[pitch]?.link)">查看详情</p>
        </div>
      </div>
      <div class="wrapNavDesc">
        <div class="list" v-for="(item, index) in info[pitch]?.info" :key="index">
          <p class="listTitle">{{ item.term }}</p>
          <p class="listDesc">{{ item.content }}</p>
        </div>
      </div>
    </div>
    <ul class="wrapTab">
      <li
        class="wrapTabList"
        :class="pitch === index ? 'pitch' : ''"
        v-for="(item, index) in info"
        :key="index"
        @click="changePitch(index)"
      >
        <p class="multiLine">{{ item.name }}</p>
      </li>
      <Btn :navArr="info" :stopId="totalPage" :style="styleBtn" @fetchNav="fetchNav" />
    </ul>
  </div>
</template>

<script setup>
import Btn from '@/components/common/2023/button.vue'
import { ref, onMounted, watch } from 'vue'
import { getForun } from '@/api/2023/index.js'
const info = ref([]) // 列表信息
const pitch = ref(0) // 当前展示的列表信息
const totalPage = ref(0) // 列表页数
const currPage = ref(1) // 当前页数
const PAGE_SIZE = 10
const styleBtn = {
  position: 'absolute',
  bottom: '-78px',
  right: '0'
}
onMounted(() => {
  fetchInfo()
})

watch(currPage, async () => {
  await fetchInfo()
})
function fetchInfo() {
  getForun()
    .then((res) => {
      const { errno, data } = res.data
      if (!errno) {
        totalPage.value = Math.ceil(data.length / PAGE_SIZE)
        info.value = data.splice((currPage.value - 1) * PAGE_SIZE, currPage.value * PAGE_SIZE)
      }
      return
    })
    .catch(() => {})
}

function toMore(link) {
  if (!link) return
  window.open(link, '_blank')
}

function changePitch(newPitch) {
  pitch.value = newPitch
}

function fetchNav(newVal) {
  currPage.value = newVal + 1
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.multiLine {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; //多行在这里修改数字即可
  overflow: hidden;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}
.wrap {
  position: relative;
  width: 100%;
  min-width: 1280px;
  height: 942px;
  background-size: cover;
  padding: 100px 0 49px;
  background-color: #fff;
  &Bgc {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  &Title {
    width: 1280px;
    margin: 0 auto;
    font-size: 40px;
    font-weight: bold;
    line-height: 32px;
    color: #00ab7a;
  }
  &Desc {
    width: 1280px;
    font-size: 28px;
    line-height: 32px;
    color: #3d3d3d;
    margin: 12px auto 40px;
  }
  &Nav {
    display: flex;
    justify-content: space-between;
    width: 1280px;
    height: 360px;
    margin: 0 auto;
    background-color: #fff;
    &Img {
      position: relative;
      width: 640px;
      height: 360px;
      img {
        width: 100%;
      }
      .desc {
        display: flex;
        position: absolute;
        bottom: 0;
        height: 80px;
        width: 100%;
        &Name {
          width: 506px;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          font-size: 22px;
          font-weight: bold;
          color: #ffffff;
          padding: 8px 24px;
          line-height: 32px;
        }
        &More {
          flex: 1;
          width: 256px;
          text-align: center;
          line-height: 80px;
          font-size: 18px;
          background: rgba(0, 171, 122, 0.8);
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
    &Desc {
      flex: 1;
      padding: 24px 0 24px 42px;
      overflow: hidden;
      .list {
        display: flex;
        max-height: 100%;
        overflow-y: scroll;
        margin-bottom: 20px;
        &Title {
          width: 64px;
          font-size: 16px;
          line-height: 28px;
          color: #3d3d3d;
          margin-right: 16px;
        }
        &Desc {
          width: 476px;
          font-size: 16px;
          line-height: 28px;
          color: #666666;
        }
      }
    }
  }
  &Tab {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 1280px;
    margin: 0 auto;
    // border: 1px solid darkblue;
    margin-top: 24px;
    &List {
      cursor: pointer;
      list-style: none;
      width: 256px;
      padding: 17px 24px;
      font-size: 16px;
      line-height: 28px;
      color: #666666;
      border-top: 6px solid transparent;
    }
    &List:nth-child(odd) {
      background-color: #fff;
    }
    &List:nth-child(even) {
      background: #fbfbfd;
    }
    &List:hover {
      background: #e3fdf6;
      color: #00ab7a;
      border-top: 6px solid #00ab7a;
    }
    .pitch {
      color: #fff;
      background: #00ab7a;
    }
  }
}
</style>
